import { io } from 'socket.io-client';
import * as Sentry from '@sentry/react';

export function initializeSocketConnection({ token }) {
    if (window.socket && window.socket.id && window.socket.connected) {
        window.socket.disconnect();
    }

    const socketOptions = {
        secure: process.env.ENV_NAME !== 'development',
        transports: ['websocket'],
    };

    if (token) {
        socketOptions.query = { token };
    }

    window.socket = io(process.env.REACT_APP_WS_URL, socketOptions);

    window.socket.on('error', (error) => {
        Sentry.captureException(error, {
            extra: {
                message: error.message,
                description: error.description,
                context: error.context,
                url: process.env.REACT_APP_WS_URL,
                tokenPresent: !!token,
            },
        });
    });

    window.socket.on('connect_error', (error) => {
        Sentry.captureException(error, {
            extra: {
                message: error.message,
                description: error.description,
                context: error.context,
                url: process.env.REACT_APP_WS_URL,
                tokenPresent: !!token,
            },
        });
    });
}
